<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-title>Cancel Allergy Appointments</ion-title>
        <ion-buttons slot="start">
          <ion-back-button href="/"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-list v-if="cancelAppointments.length > 0">
        <ion-item
          text-center
          v-for="cancelAppointment in cancelAppointments"
          :key="cancelAppointment.id"
        >
          <ion-label>
            <ion-button
              size="default"
              class="adjust-font-size"
              expand="block"              
              @click="cancelTheAppointment(cancelAppointment.id)"
              >{{ cancelAppointment.appointmentDescription }}</ion-button
            >
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </div>
</template>

<script>
import Repository from "../../repositories/RepositoryFactory";
const AppointmentsRepository = Repository.get("appointments");

export default {
  name: "adminmainpage",
  model: "",
  appointmentDate: "",
  data() {
    return {
      cancelAppointments: []
    };
  },
  created: async function() {
    let self = this;
    const result = await AppointmentsRepository.cancelShotAppointment(
      this.$store.state.userId
    );

    // eslint-disable-next-line no-console
    console.log(result.data);

    if (result.data.length < 1) {
      alert("No Appointments to Cancel");
      self.$router.push({ name: "main" });
    }

    this.cancelAppointments = result.data;
  },

  methods: {
    changePassword() {
      let self = this;
      self.$router.push({ name: "change" });
    },

    //onChange(event) {
    onChange: async function(event) {
      this.appointmentDate = this.$refs.theAppointmentDate.value;
      // eslint-disable-next-line no-console
      console.log(event);
      const result = await AppointmentsRepository.getUntakenShotAppointments(
        this.appointmentDate + "~" + this.$store.state.location
      );

      // eslint-disable-next-line no-console
      //console.log(event.target.value);
      this.openAppointments = result.data;
      //eslint-disable-next-line no-console
      console.log(result.data);
    },
    //onChange: async function(event) {
    cancelTheAppointment: async function(appointmentId) {
      let self = this;
      const result = await AppointmentsRepository.deleteShotAppointment(
        appointmentId
      );

      if (result.data.status === "Success") {
        // eslint-disable-next-line no-console
        console.log(result);
        self.$router.push({ name: "main" });
      } else {
        alert("Issue With Canceling Appointment");
      }
      // eslint-disable-next-line no-console
      console.log(result);
    }
  }
};
</script>
